import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useState } from "react";
import { useStyledBlock, StyleControls } from "./StyleControls";
import { MediaPicker } from "@/components/admin/MediaPicker";
import type { BlockSettingsTabProps } from "./BreakpointSwitcher";
import type { GalleryImage } from "@/components/craft/blocks/GridGalleryBlock";

type GalleryProps = { images: GalleryImage[]; columns?: 2 | 3 | 4 };

export function GridGalleryBlockSettings({ tab, breakpoint }: BlockSettingsTabProps) {
  const { props, setProp, style, updateStyle } = useStyledBlock<GalleryProps>();
  const [pickerOpen, setPickerOpen] = useState(false);

  if (tab === "content") {
    return (
      <div className="space-y-3">
        <div className="space-y-1">
          <Label className="text-xs">Columns</Label>
          <Select
            value={String(props.columns ?? 3)}
            onValueChange={(v) => setProp((p) => { p.columns = Number(v) as GalleryProps["columns"]; })}
          >
            <SelectTrigger className="h-8 text-xs"><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="2">2</SelectItem>
              <SelectItem value="3">3</SelectItem>
              <SelectItem value="4">4</SelectItem>
            </SelectContent>
          </Select>
        </div>
        <Button type="button" variant="outline" size="sm" className="h-7 text-xs" onClick={() => setPickerOpen(true)}>
          Add from library
        </Button>
        <MediaPicker
          open={pickerOpen}
          onOpenChange={setPickerOpen}
          onSelect={(sel) =>
            setProp((p) => {
              if (!sel.url) return;
              p.images = [...(p.images ?? []), { url: sel.url, mediaId: sel.mediaId, alt: sel.altText ?? "" }];
            })
          }
        />
        <p className="text-xs text-muted-foreground">{(props.images ?? []).length} image(s)</p>
      </div>
    );
  }
  if (tab === "style") {
    return <StyleControls style={style} updateStyle={updateStyle} breakpoint={breakpoint} showBackground={false} />;
  }
  return null;
}
